
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增用车申请
export function addTheCarApplication(params) {
    return post(`${HOST}the-car-application/save`, params)
}
// 修改用车申请
export function updateTheCarApplication(params) {
    return post(`${HOST}the-car-application/update`, params)
}
//用车申请列表
export function getTheCarApplication(params) {
    return get(`${HOST}the-car-application/list`, params)
}
//用车申请草稿箱列表
export function TheCarApplicationDraftlist(params) {
    return get(`${HOST}the-car-application/draftlist`, params)
}
//用车申请详情
export function TheCarApplicationDetial(params) {
    return get(`${HOST}the-car-application/get`, params)
}
// 删除用车申请
export function delTheCarApplication(params) {
    return del(`${HOST}the-car-application/delete`, params)
}







// WEBPACK FOOTER //
// ./src/views/ApplicationForVehicle/api/api.js